import { Box, Grid, styled } from '@material-ui/core';
import { SButton } from '@setvi/shared/components';

export const Container = styled(Grid)(() => ({
  display: 'grid',
  borderRadius: 12,
  justifyContent: 'space-between',
  gridTemplateColumns: '33% 24px 1fr',
  gap: 8
}));

export const FlexRow = styled(Box)({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
  backgroundColor: '#fff',
  padding: '16px 16px 6px',
  borderRadius: 16,
  border: '1px solid #EEF0F2',
  height: '260px',
  boxSizing: 'border-box'
});

export const FlexCol = styled(Box)({
  display: 'flex',
  width: '100%',
  flexDirection: 'column',
  gap: 12
});

export const iconStyle = {
  fontWeight: 600,
  fontSize: 14,
  borderRadius: 36
};

export const NoMatchContainer = styled(Box)(({ theme }) => ({
  padding: '24px',
  display: 'flex',
  alignItems: 'center',
  height: '100%',
  gridGap: theme.spacing(2),
  backgroundColor: '#fff',
  border: '1px solid #EEF0F2',
  borderRadius: 16
}));

export const NoMatchContent = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gridGap: 12
});

export const NoMatchButtonContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 12
});

export const ManuallTag = styled(Box)(({ theme }) => ({
  flex: 1,
  alignItems: 'center',
  justifyContent: 'center',
  display: 'flex',
  borderRadius: 12,
  width: 75,
  maxWidth: 75,
  fontSize: 13,
  height: 24,
  gap: 4,
  color: '#F0A04B',
  padding: theme.spacing(0, 2),
  cursor: 'default',
  backgroundColor: 'transparent',
  border: '1px solid #F0A04B'
}));

export const LabelBtn = styled(SButton)({
  padding: '0px 16px',
  borderRadius: 36,
  fontWeight: 600,

  '&:hover': {
    background: '#EBF5FF !important'
  }
});

export const RemovedBadge = styled(Box)({
  background: '#FED2D2',
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 32,
  height: 32
});
